module.exports = __webpack_public_path__ + "img/03.0eea0d07.gif";